module.exports = __webpack_public_path__ + "static/tcdd-trafik-artisi-77c9626436dff72615562d9cf6f1bf59.png";